import {
  StoreCreditReport,
  FetchCreditReportAction,
  FetchCreditReportSuccessAction,
  FetchCreditReportsAction,
  FetchCreditReportsSuccessAction,
  FetchCreditReportFailAction,
  FetchCreditReportsFailAction,
} from '@funnels/types';
import { REDUX_STORE } from '@funnels/constants';

export function fetchCreditReport(applicantId: string): FetchCreditReportAction {
  return { type: REDUX_STORE.CREDIT_REPORTS.ACTION_TYPES.FETCH_CREDIT_REPORT, applicantId };
}

export function fetchCreditReportSuccess(
  applicantId: string,
  creditReport: StoreCreditReport
): FetchCreditReportSuccessAction {
  return { type: REDUX_STORE.CREDIT_REPORTS.ACTION_TYPES.FETCH_CREDIT_REPORT_SUCCESS, creditReport, applicantId };
}

export function fetchCreditReports(applicationId: string): FetchCreditReportsAction {
  return { type: REDUX_STORE.CREDIT_REPORTS.ACTION_TYPES.FETCH_CREDIT_REPORTS, applicationId };
}

export function fetchCreditReportsSuccess(): FetchCreditReportsSuccessAction {
  return { type: REDUX_STORE.CREDIT_REPORTS.ACTION_TYPES.FETCH_CREDIT_REPORTS_SUCCESS };
}

export function fetchCreditReportFail(message: string): FetchCreditReportFailAction {
  return { type: REDUX_STORE.CREDIT_REPORTS.ACTION_TYPES.FETCH_CREDIT_REPORT_FAIL, message };
}

export function fetchCreditReportsFail(message: string): FetchCreditReportsFailAction {
  return { type: REDUX_STORE.CREDIT_REPORTS.ACTION_TYPES.FETCH_CREDIT_REPORTS_FAIL, message };
}
